import React from "react";
import { NumberInput } from "react-admin";

const FormTab = (props) => {
  const s = (fieldName) => `players.${props.index}.football.${fieldName}`;
  return (
    <>
      <NumberInput
        label="Passing Completions"
        source={s("passingCompletions")}
      />
      <NumberInput label="Passing Attempts" source={s("passingAttempts")} />
      <NumberInput label="Passing Yards" source={s("passingYards")} />
      <NumberInput label="Passing Touchdowns" source={s("passingTouchdowns")} />
      <NumberInput
        label="Passing Interceptions"
        source={s("passingInterceptions")}
      />
      <NumberInput
        label="Passing Completion Percentage"
        source={s("passingCompletionPercentage")}
      />
      <NumberInput label="Rushing Attempts" source={s("rushingAttempts")} />
      <NumberInput label="Rushing Yards" source={s("rushingYards")} />
      <NumberInput label="Rushing Touchdowns" source={s("rushingTouchdowns")} />
      <NumberInput label="Rushing Average" source={s("rushingAverage")} />
      <NumberInput label="Receptions" source={s("receptions")} />
      <NumberInput label="Receiving Yards" source={s("receivingYards")} />
      <NumberInput
        label="Receiving Touchdowns"
        source={s("receivingTouchdowns")}
      />
      <NumberInput label="Receiving Average" source={s("receivingAverage")} />
      <NumberInput label="Total Points" source={s("totalPoints")} />
    </>
  );
};

export default FormTab;
